<template>
  <div class="organization">
    <div class="title">
      <img class="title_img"
           src="../../../../assets/images/08/zuzhi_icon.png"
           alt="">
      省市区管理
    </div>
    <div class="main">
      <el-table :data="data"
                ref="multipleTable"
                style="width: 100%"
                class="main-data"
                height="100%">

        <el-table-column header-align="center"
                         align="left"
                         label="区域名称">
          <template slot-scope="scope">
            <div class="structureName"
                 @click="toggle(scope.row)"
                 size="medium">
              {{scope.row.provinceName}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="区域编号"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <div>{{scope.row.provinceCode}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         class="operation"
                         header-align="center"
                         align="left"
                         width="165">
          <template slot-scope="scope">
            <el-tooltip class="item addNew"
                        effect="dark"
                        content="添加子结构"
                        placement="top">
              <el-button @click="handleAddCityClick(scope.row.provinceCode)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table :data="props.row.city"
                      ref="childTable"
                      class="detailTable">
              <el-table-column align="left">
                <template slot-scope="props">
                  <div class="subTitlename"
                       @click="childtoggle(props.row)"
                       size="medium">
                    {{props.row.cityName}}
                  </div>
                  <!-- <div class="subTitlename">{{props.row.name}}</div> -->
                </template>
              </el-table-column>
              <el-table-column align="center">
                <template slot-scope="props">
                  <div>{{props.row.cityCode}}</div>
                </template>
              </el-table-column>
              <el-table-column width="165">
                <template slot-scope="props">
                  <el-tooltip class="item addNew"
                              effect="dark"
                              content="添加子结构"
                              placement="top">
                    <el-button @click="handleAddAreaClick(props.row.cityCode)"></el-button>
                  </el-tooltip>
                  <el-tooltip class="item update"
                              effect="dark"
                              content="修改"
                              placement="top">
                    <el-button @click="handleUpdateCityClick(props.row.cityId)"></el-button>
                  </el-tooltip>

                  <el-tooltip class="item delete"
                              effect="dark"
                              content="删除"
                              placement="top">
                    <el-button @click="handleDeleteCityClick(props.row.cityId)"></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table :data="props.row.area"
                            class="detailTable">
                    <el-table-column align="left">
                      <template slot-scope="cscope">
                        <div class="areaList"
                             size="medium">
                          {{cscope.row.areaName}}
                        </div>
                        <!-- <div class="subTitlename">{{props.row.name}}</div> -->
                      </template>
                    </el-table-column>
                    <el-table-column align="center">
                      <template slot-scope="cscope">
                        <div>{{cscope.row.areaCode}}</div>
                      </template>
                    </el-table-column>
                    <el-table-column width="165"
                                     class-name="area_options"
                                     align="right">
                      <template slot-scope="cscope">
                        <el-tooltip class="item update"
                                    effect="dark"
                                    content="修改"
                                    placement="top">
                          <el-button @click="handleUpdateClick(cscope.row.areaId)"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item delete"
                                    effect="dark"
                                    content="删除"
                                    placement="top">
                          <el-button @click="handleDeleteClick(cscope.row.areaId)"></el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column type="expand">
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog :title="areaTitle"
                 :visible.sync="dialogVisible"
                 class="biddingTable"
                 :before-close="handleClose">
        <div class="arealist">
          <span>当前{{titleName}}名称：</span>{{areaname}}
        </div>
        <div class="arealist">
          <span>{{valName}}名称：</span>
          <el-input v-model="addCityName"
                    size="small"></el-input>
        </div>
        <div class="addBtn"
             @click="handleAddClick()">确定</div>
      </el-dialog>
    </div>
    <!-- <div class="pages">
            <span class="demonstartion"> 共{{emailData.total}}条记录</span>
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="emailData.pageSize"
                layout="prev, pager, next"
                :total="emailData.total"
                background
            >
            </el-pagination>
        </div> -->
  </div>
</template>
<script>
import {
  getArea,
  getProvinceInfo,
  addCity,
  getCityInfo,
  addArea,
  deleteArea,
  updateGetArea,
  updateArea,
  updateGetCity,
  updateCity,
  deleteCity
} from 'apis/index'
export default {
  name: 'operation',
  data () {
    return {
      data: [],
      dialogVisible: false,
      areaTitle: '添加区域名称',
      addCityName: '',
      areaname: '',
      addType: '1', // 1添加市，2添加区 , 3修改区
      provinceCode: '',
      cityCode: '',
      areaId: '',
      titleName: '省',
      valName: '添加市'
    }
  },
  methods: {
    getData () { // 获取数据
      getArea().then(res => {
        if (res.data.code === 200) {
          this.data = res.data.data
          console.log(this.data)
        }
      })
    },
    toggle (row) { // 子结构
      this.$refs.multipleTable.toggleRowExpansion(row)
    },
    childtoggle (row) { // 子结构
      this.$refs.childTable.toggleRowExpansion(row)
    },
    handleAddCityClick (code) { // 添加市
      // console.log(code)
      getProvinceInfo({
        provinceCode: code
      }).then(res => {
        if (res.data.code === 200) {
          // console.log(res)
          this.areaTitle = '添加区域名称'
          this.titleName = '省'
          this.valName = '添加市'
          this.dialogVisible = true
          this.areaname = res.data.data[0].provinceName
          this.addType = '1'
          this.provinceCode = res.data.data[0].provinceCode
        }
      })
    },
    handleAddClick () { // 确认添加
      // console.log(
      //   'proCode', this.provinceCode,
      //   'cityCode', this.cityCode
      // )
      if (this.addCityName) {
        if (this.addType === '1') {
          addCity({
            provinceCode: this.provinceCode,
            cityName: this.addCityName
          }).then(res => {
            if (res.data.code === 200) {
              this.areaname = ''
              this.addCityName = ''
              this.provinceCode = ''
              this.cityCode = ''

              this.getData()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
            }
          })
        } else if (this.addType === '2') {
          // console.log('添加区')
          // console.log(this.cityCode, this.addCityName)
          addArea({
            cityCode: this.cityCode,
            areaName: this.addCityName
          }).then(res => {
            // console.log(res)
            if (res.data.code === 200) {
              this.areaname = ''
              this.addCityName = ''
              this.provinceCode = ''
              this.cityCode = ''

              this.getData()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
            }
          })
        } else if (this.addType === '3') {
          // console.log('修改区')
          // console.log(this.areaId)
          updateArea({
            areaId: this.areaId,
            areaName: this.addCityName
          }).then(res => {
            // console.log(res)
            if (res.data.code === 200) {
              this.areaname = ''
              this.addCityName = ''
              this.provinceCode = ''
              this.cityCode = ''
              this.areaId = ''

              this.getData()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
            }
          })
        } else if (this.addType === '4') {
          // 修改市
          console.log(this.areaId, this.areaTitle, this.addCityName)

          updateCity({
            cityId: this.areaId,
            cityName: this.addCityName
          }).then(res => {
            if (res.data.code === 200) {
              this.areaname = ''
              this.addCityName = ''
              this.provinceCode = ''
              this.cityCode = ''
              this.areaId = ''

              this.getData()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
            }
          })
        }
        // this.getData()
        this.dialogVisible = false
      }
    },
    handleUpdateCityClick (cityId) { // 修改市
      console.log(cityId)
      updateGetCity({
        cityId: cityId
      }).then(res => {
        console.log('xiugaishi', res)
        if (res.data.code === 200) {
          console.log(res)
          this.areaTitle = '修改市'
          this.titleName = '省'
          this.valName = '修改市'
          this.dialogVisible = true
          this.areaname = res.data.data[0].provinceName
          this.addType = '4'
          this.addCityName = res.data.data[0].city[0].cityName
          this.areaId = cityId
        }
      })
    },
    handleDeleteCityClick (cityId) { // 删除市
      console.log(cityId)
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCity({
          cityId: cityId
        }).then(res => {
          if (res.data.code === 200) {
            this.$message({
              message: '删除成功！',
              type: 'success'
            })
            this.getData()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleAddAreaClick (cityCode) { // 添加区
      getCityInfo({
        cityCode: cityCode
      }).then(res => {
        // console.log(res)
        this.data.forEach(element => {
          if (element.provinceCode === res.data.data[0].provinceCode) {
            this.areaname = element.provinceName
          }
        })
        this.titleName = '市'
        this.valName = '添加区'
        this.areaname += ' , ' + res.data.data[0].cityName
        this.cityCode = res.data.data[0].cityCode
        this.addType = '2'
        this.dialogVisible = true
      })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.addCityName = ''
          this.provinceCode = ''
          this.cityCode = ''
          this.areaname = ''
          done()
        })
        .catch(_ => { })
    },

    handleUpdateClick (id) { // 修改区
      // console.log('aaaa', this.addType, id)
      // console.log(id)
      this.areaTitle = '修改区域名称'
      this.titleName = '市'
      this.valName = '修改区'
      updateGetArea({
        areaId: id
      }).then(res => {
        if (res.data.code === 200) {
          // console.log(res)
          this.areaname = res.data.data[0].provinceName + ' , ' + res.data.data[0].city[0].cityName
          this.addCityName = res.data.data[0].city[0].area[0].areaName
          this.addType = '3'
          this.areaId = id
          this.dialogVisible = true
        }
      })
      //   this.$router.push({path: 'organiz/addOrganization', query: {'company': id}})
    },
    handleDeleteClick (id) { // 删除区
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteArea({
          areaId: id
        }).then(res => {
          if (res.data.code === 200) {
            this.$message({
              message: '删除成功！',
              type: 'success'
            })
            this.getData()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleCurrentChange (val) { // 分页
      //   let pageNum = val
      //   emailList({pageNum}).then(res => {
      //     if (res.data.code === 200) {
      //       this.emailData = res.data.data
      //     }
      //   })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.organization
  height 100%
  padding 20px
  .title
    width 100%
    height 46px
    line-height 46px
    color #212832
    background #fff
    border-bottom 1px solid #cfd5dc
    .title_img
      margin 0 8px 0 14px
  .main
    width 100%
    height calc(100% - 66px)
    .el-table
      background #f7f9fb
      th
        background #e7f0f8
        .cell
          height 25px
          line-height 25px
      td
        height 80px
        .cell
          size12()
          .structureName
            padding-left 80px
            cursor pointer
            background-image url('../../../../assets/images/08/xiala_n_icon.png')
            background-repeat no-repeat, no-repeat
            background-position 47px
            &:hover
              background-image url('../../../../assets/images/08/xiala_h_icon.png')
              background-repeat no-repeat
              background-position 47px
          .el-icon-arrow-right:before
            content ''
          .el-button
            padding 6px 14px
            width 28px
            cursor pointer
            height 28px
            margin 0 8px
            &.update
              background url('../../../../assets/images/03/icon_x.png') no-repeat
              &:hover
                background url('../../../../assets/images/03/icon_xh.png') no-repeat
            &.unblocked
              background url('../../../../assets/images/05/jinyong_icon.png') no-repeat
              &:hover
                background url('../../../../assets/images/05/jiejin_icon.png') no-repeat
            &.delete
              background url('../../../../assets/images/03/icon_delete.png') no-repeat
              &:hover
                background url('../../../../assets/images/03/icon_deleteh.png') no-repeat
            &.addNew
              background url('../../../../assets/images/08/add_cp_icon.png') no-repeat
              &:hover
                background url('../../../../assets/images/08/add_cp_h_icon.png') no-repeat
      .el-table
        thead
          display none
        td
          .cell
            .subTitlename
              cursor pointer
              padding-left 95px
              background-image url('../../../../assets/images/08/xiala_n_icon.png')
              background-repeat no-repeat, no-repeat
              background-position 67px
              &:hover
                background-image url('../../../../assets/images/08/xiala_h_icon.png')
                background-repeat no-repeat
                background-position 67px
            .areaList
              padding-left 115px
      .el-table__expanded-cell
        padding 0
      .el-table td, .el-table th.is-leaf
        border-bottom none
  .biddingTable
    .el-dialog
      width 444px
      font-size 12px
      .el-dialog__header
        height 42px
        padding 0 20px 0
        background #1b88ee
        .el-dialog__title
          line-height 42px
          font-size 13px
          color #fff
          float left
        .el-dialog__headerbtn
          top 12px
          right 12px
          .el-dialog__close
            color #fff
            font-size 20px
      .el-dialog__body
        padding 20px 20px
        .arealist
          width 260px
          // background #ff6666
          margin 20px auto 0
          font-size 12px
          color #212832
          span
            color #5E656F
          .el-input
            width 168px
            height 32px
            display inline-block
        .addBtn
          width 112px
          height 28px
          color #fff
          background #1B88EE
          text-align center
          line-height 28px
          font-size 12px
          margin 40px auto 0
          border-radius 3px
  .el-pagination
    color #5e656f
    font-weight 100
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
    border 1px solid #cfd5dc
    background #fff
  .pages
    margin-top 15px
    .demonstartion
      float right
      line-height 45px
      color #5e656f
</style>
